{
  "YOUR_FEEDBACK_SUGGESTION_HELP_IMPROVE_PRODUCT": "Sus comentarios y sugerencias nos ayudarán a mejorar nuestro producto y servicios.",
  "TECHNICAL_ISSUES_CONTACT_ADMIN_OR_SP": "Si tiene un problema técnico o de soporte, o requiere asistencia inmediata, por favor contacte a su Administrador de Laserfiche o Proveedor de Soluciones según lo indicado en su contrato de servicio.",
  "FOUND_SOMETHING_LIKE_DISLIKE_LET_US_KNOW": "¿Encontró algo que le guste o disguste? Háganoslo saber.",
  "DO_YOU_HAVE_IDEA_NEW_FEATURE_IMPROVEMENT_LOOK_FORWARD_TO_HEARING": "¿Tiene una idea para una nueva función o una mejora? Esperamos conocerla.",
  "PLEASE_DO_NOT_INCLUDE_CONFIDENTIAL_OR_PERSONAL_INFO_IN_FEEDBACK": "Por favor, no incluya información confidencial o personal en sus comentarios",
  "TELL_US_ABOUT_EXPERIENCE": "Cuéntenos sobre su experiencia",
  "TELL_US_ABOUT_IDEA": "Cuéntenos sobre su idea",
  "I_HAVE_FEEDBACK": "Tengo comentarios",
  "I_HAVE_SUGGESTION": "Tengo una sugerencia",
  "YOU_MAY_CONTACT_ME_ABOUT_FEEDBACK": "Puede contactarme respecto a este comentario",
  "IF_YOUD_LIKE_TO_JOIN_OUR_CUSTOMER_PANEL": "Si desea unirse a nuestro Panel de Clientes,",
  "PLEASE_CLICK_HERE": "por favor haga clic aquí.",
  "IMAGE_EXCEEDS_MAX_FILE_SIZE_0": "La imagen excede el tamaño máximo de archivo de {0}.",
  "IMAGE_CORRUPTED_UNRECOGNIZED_FORMAT": "La imagen está dañada o en un formato no reconocido.",
  "ACCEPTED_FORMATS_ARE_0": "Los formatos aceptados son: {0}.",
  "IMAGE_NOT_ATTACHED": "Imagen no adjuntada.",
  "ATTACH_IMAGE": "Adjuntar imagen",
  "PLEASE_ATTACH_ONLY_ONE_IMAGE": "Por favor, adjunte solo una imagen.",
  "TAGS": "Etiquetas",
  "ADD_TAGS": "Agregar etiquetas",
  "ADD_MORE_TAGS": "Agregar más etiquetas",
  "NO_TAGS_AVAILABLE": "No hay etiquetas disponibles"
}
